import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { makeListingsStateManagerViewPath } from 'client/helpers/listingsStateManager';

import { SR_API_ACTION_GET_LISTING_LIST } from 'api/actionTypes';

import SrText from 'client/components/SrText';
import ListingCard from 'client/components/ListingCard';

import branch from 'client/core/branch';
import withInfiniteScroll from 'client/helpers/withInfiniteScroll';
import withApiState from 'client/helpers/withApiState';

@withInfiniteScroll({
  offset: 32,
})
@withApiState(({ viewId }) => ({
  getListingsApiState: {
    action: SR_API_ACTION_GET_LISTING_LIST,
    queryId: viewId,
  },
}))
@branch(({ viewId }) => ({
  currentUser: ['currentUser'],
  listingPhotoResolution: ['listingPhotoResolution'],
  listings: makeListingsStateManagerViewPath(viewId).concat(['$listings']),
  isFullyLoaded: makeListingsStateManagerViewPath(viewId).concat(['isFullyLoaded']),
}))
class SrInfiniteListingView extends Component {
  static propTypes = {
    viewId: PropTypes.string.isRequired, // eslint-disable-line react/no-unused-prop-types
    title: PropTypes.string.isRequired,
    onLoadMore: PropTypes.func,
    requestedFrom: PropTypes.string.isRequired,
    onInfiniteScrollWrapperRef: PropTypes.func.isRequired,
    onInfiniteScrollCallbackReady: PropTypes.func.isRequired,
    getListingsApiState: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    listings: PropTypes.array,
    isFullyLoaded: PropTypes.bool,
    listingPhotoResolution: PropTypes.number.isRequired,
    showThumbnailApartmentUnit: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    const { onInfiniteScrollCallbackReady, onLoadMore } = props;

    if (onLoadMore && onInfiniteScrollCallbackReady) {
      onInfiniteScrollCallbackReady(this._onLoadMore);
    }
  }

  _onLoadMore = () => {
    const { isFullyLoaded, onLoadMore } = this.props;
    if (!isFullyLoaded) {
      onLoadMore();
    }
  };

  render() {
    const {
      title,
      listings,
      currentUser,
      getListingsApiState,
      onInfiniteScrollWrapperRef,
      listingPhotoResolution,
      showThumbnailApartmentUnit,
      requestedFrom,
    } = this.props;

    return (
      <div className="SrInfiniteListingView" ref={onInfiniteScrollWrapperRef}>
        <SrText size="2xl" weight="bold">
          {title}
        </SrText>
        <div style={{ height: 20 }} />
        <div className="listings clearfix">
          {(listings || []).map((listing) => (
            <ListingCard
              requestedFrom={requestedFrom}
              enableBookmarkButton
              key={listing.id}
              listing={listing}
              currentUser={currentUser}
              photoResolution={listingPhotoResolution}
              showThumbnailApartmentUnit={showThumbnailApartmentUnit}
            />
          ))}
        </div>
        {getListingsApiState.inProgress && <div className="loading-gif clearfix" />}
      </div>
    );
  }
}

SrInfiniteListingView.displayName = 'SrInfiniteListingView';

export default SrInfiniteListingView;
